export const AppSettings = {
    appName: "Veins",
    appIcon: "",//https://www.runebox.xyz/images/logo.png
}